"use client";
import LeadService from "@/utils/api/leadService";
import { useFormik } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openPopup } from "@/redux/slices/popupSlice";
import { showSnackbar } from "@/redux/slices/snackbarSlice";
import { useRouter } from "next/navigation";
import { markLeadAsGenerated } from "@/redux/slices/leadSlice";
import { sendAnalytics } from "@/utils/helpers/analytics";
const useLeadForm = ({ formName }) => {
  const [loading, setLoading] = useState(false);
  const { city } = useSelector((state) => state.location);
  const { popupData } = useSelector((state) => state.popups);
  const router = useRouter();
  const dispatch = useDispatch();

  const form = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    initialValues: {
      name: "",
      mobile: "",
      checkbox: true,
      city: city,
      buttonType: null,
      consent: false,
      buttonText : null
    },

    validate: (values) => {
      const errors = { ...values?.errors };

      if (!values?.mobile?.toString()) {
        errors.mobile = "Mobile Number is Mandatory";
      }
      if (values?.mobile?.toString()?.length !== 10) {
        errors.mobile = "Please enter valid number";
      }
      if (values?.mobile && values?.mobile[0] < 5) {
        errors.mobile = "Please enter valid number";
      }
      if (!values?.city) {
        errors.state = "City is Mandatory";
      }
      if (!values?.consent) {
        errors.consent = "Please check the consent box";
      }
      return errors;
    },

    onSubmit: (values) => {
      const payload = {
        name: values?.name,
        phone: values?.mobile,
        city: values?.city,
      };
      LeadService(payload)
        .then((response) => {
          setLoading(false);
          sendAnalytics(
            "lead_form_submit",
            {
              "form_name": formName,
              "city_name": values?.city,
              "button_text": values?.buttonText,
            }
          );
          if(popupData?.redirectUrl) {
            router.push(popupData.redirectUrl);
          }
          dispatch(markLeadAsGenerated());
          dispatch(
            openPopup({
              popupId: "thankYouPopup",
            })
          );
          if (values?.buttonType === "call") {
            window.location.href = `tel:08047484881`;
          } else if (values?.buttonType === "whatsapp") {
            window.open(`https://wa.me/+08047484881?text=Hi`);
          }
        })
        .catch((error) => {
          dispatch(
            showSnackbar(
              error?.response?.data?.message ||
                "Oops, something went wrong. Please try again later.",
              "error"
            )
          );
          setLoading(false);
        });
    },
  });
  return {
    form,
    loading,
  };
};

export default useLeadForm;
